import {
  runObjectExtender
} from "@/core/js-extender/object.extender";
runObjectExtender();

const toCurrency = Object.toCurrency;
const toPercent = Object.toPercent;
const toFixedString = Object.toFixedString;

export {
  toCurrency,
  toPercent,
  toFixedString
}



// WEBPACK FOOTER //
// ./src/filters/index.js